export const getTimeSince = (date) => {
  const intervals = Object.entries({
    year: 31536000,
    month: 2592000,
    day: 86400,
    hr: 3600,
    min: 60,
  });

  let seconds = Math.floor((new Date() - new Date(date)) / 1000);
  seconds = seconds < 0 ? 0 : seconds;
  let match = `${Math.floor(seconds)} seconds ago`;
  for (let i = 0; i < intervals.length; ++i) {
    const [name, amount] = intervals[i];
    const interval = Math.floor(seconds / amount);
    if (interval > 0) {
      match = `${interval} ${name}${interval > 1 ? 's' : ''} ago`;
      break;
    }
  }

  return match.includes('NaN') ? undefined : match;
};

export default getTimeSince;
